export default __webpack_public_path__ + "static/solaris-busstacja-86392632893ae606dd785e2e7690aba6.png";